import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12a8 8 0 0 1 16 0z","key":"svg-0"}],["path",{"d":"M12 12v6a2 2 0 0 0 4 0","key":"svg-1"}]]

const IconUmbrella = createReactComponent('outline', 'umbrella', 'Umbrella', __iconNode);

export default IconUmbrella;